module.exports = __webpack_public_path__ + "static/adm_fun-b01be48da709ccbf88a1ea9d811a850b.jpg";